// src/modules/app-views/crm/pages/Kanban/modals/NewOpportunityFormModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Divider, Form, Row } from 'antd';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimplePhone from 'components/SimpleComponents/SimplePhone';
import SimpleEmail from 'components/SimpleComponents/SimpleEmail';
import SimpleUsers from 'components/SimpleComponents/SimpleUsers';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import FormFieldsRenderer from '../../../../components/FormFieldsRenderer';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step1 = ({ formFields, columnUid, opportunityField, intrinsicFieldLabels }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. HOOKS
  // ─────────────────────────────────────────────────────────────────────────────
  const { form } = useSimpleFormContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const phoneValue = Form.useWatch(['phone', 'value'], form);
  const emailValue = Form.useWatch(['email', 'value'], form);
  const hasContact = !!(phoneValue?.trim() || emailValue?.trim());
  const hasOpportunityComposition = opportunityField?.length > 0;
  const labels = intrinsicFieldLabels || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-2">
      {/* ROW 1: Name & UniqueKey */}
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimpleInput name="name" label={labels.name || 'contact_name'} required autoFocus />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleInput name="uniqueKey" label={labels.uniqueKey || 'unique_key'} tooltip="unique_key_help" />
        </Col>
      </Row>

      {/* ROW 2: Phone & Email */}
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimplePhone
            name={['phone', 'value']}
            label={labels.phone || 'phone'}
            international
            required={!hasContact}
          />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleEmail name={['email', 'value']} label={labels.email || 'email'} required={!hasContact} />
        </Col>
      </Row>

      {/* ROW 3: Responsible consultant */}
      <Row gutter={16}>
        <Col xs={24}>
          <SimpleUsers name="consultantId" label="responsible_consultant" required />
        </Col>
      </Row>

      {/* ROW 4: Opportunity — only when no opportunityField composition is defined */}
      {!hasOpportunityComposition && (
        <Row gutter={16}>
          <Col xs={24}>
            <SimpleInput name="opportunity" label={labels.opportunity || 'opportunity_description'} required />
          </Col>
        </Row>
      )}

      {/* Divider + Custom form fields */}
      <Divider style={{ margin: '8px 0 16px' }} />
      <FormFieldsRenderer formFields={formFields} columnUid={columnUid} />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1;
